import React from 'react';

function Footer() {
  return (
    <footer className="relative bottom-0 left-0 right-0 flex flex-col items-start bg-black px-5 py-8 md:absolute md:px-[114px] md:py-[40px]">
      <p className="text-[13px] font-medium leading-[19.5px] text-gray-400">
        상호명 (주)하우스버디 | 대표자 임지은 | 개인정보책임자 임지은 | 사업자 등록번호 586-87-03123 |{' '}
        <a
          href="http://www.ftc.go.kr/bizCommPop.do?wrkr_no=5868703123"
          target="_blank"
          rel="noopener noreferrer"
          className="cursor-pointer hover:underline"
        >
          통신판매업신고번호: 2024-서울동작-0725
        </a>
      </p>
      <p className="text-[13px] font-medium leading-[19.5px] text-gray-400">
        서울특별시 동작구 현충로지하220 창업스튜디오 A-02호
      </p>
      <p className="text-[13px] font-medium leading-[19.5px] text-gray-400">
        <a
          href="https://buttercup-coral-e9a.notion.site/91d9819b2dcd44f3b565a02360f28da1?pvs=4"
          target="_blank"
          rel="noopener noreferrer"
          className="cursor-pointer hover:underline"
        >
          이용약관{' '}
        </a>
        |{' '}
        <a
          href="https://buttercup-coral-e9a.notion.site/199c00e56086801c8ddafaae9a354388"
          target="_blank"
          rel="noopener noreferrer"
          className="cursor-pointer hover:underline"
        >
          개인정보처리방침
        </a>{' '}
        | 고객지원: official@checkmatekorea.com | 고객센터: 010-8703-3395
      </p>
      <p className="text-[13px] font-medium leading-[19.5px] text-gray-400">애스크로 인증마크</p>
    </footer>
  );
}

export default Footer;
